const applyToolEvent = (calls, event) => {
  if (event.type === "tool_call") {
    return [...calls, { id: event.id, tool: event.tool, status: "running" }];
  }
  return calls.map(
    (call) => call.id === event.id ? { ...call, status: event.failed ? "failed" : "done", durationMs: event.duration_ms } : call
  );
};
export default applyToolEvent;
